// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2W00h","footer":"ModalCreateQualiphyProcedure_footer__3X7nC","additionData":"ModalCreateQualiphyProcedure_additionData__3UTYT"};